<template>
  <v-menu left offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab depressed small v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="showDataUploadDialog(item)">
        <v-list-item-title>
          <v-icon left>mdi-cloud-upload</v-icon>
          <span>データアップロード</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="viewFolderList(item)">
        <v-list-item-title>
          <v-icon left>mdi-folder-cog</v-icon>
          <span>データ管理</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="showDetail(item)">
        <v-list-item-title>
          <v-icon left>mdi-page-next</v-icon>
          <span>詳細</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="openEditPlantDialog(item)">
        <v-list-item-title>
          <v-icon left>mdi-pencil</v-icon>
          <span>情報編集</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  name: "PlantActionOptions",
  props: ['item', 'showDataUpload', 'viewFolder', 'show', 'edit'],
  data() {
    return {
    }
  },
  methods: {
    showDataUploadDialog(item){
      this.$emit('showDataUpload', item);
    },
    viewFolderList(item){
      this.$emit('viewFolder', item);
    },
    showDetail(item){
      this.$emit('show', item);
    },
    openEditPlantDialog(item){
      this.$emit('edit', item);
    }
  }
}
</script>

<style scoped>

</style>
